export default {"src":"/_next/static/media/rewards.81d32672.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};